var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#B5B8C5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8999 17.7536L19.6732 17.5536C19.0302 16.9807 18.4673 16.3236 17.9999 15.6003C17.4894 14.602 17.1834 13.5117 17.0999 12.3936V9.10026C17.1043 7.344 16.4672 5.64658 15.3084 4.32691C14.1495 3.00724 12.5486 2.15617 10.8065 1.93359V1.07359C10.8065 0.837551 10.7128 0.611176 10.5459 0.444269C10.379 0.277361 10.1526 0.183594 9.91654 0.183594C9.68049 0.183594 9.45412 0.277361 9.28721 0.444269C9.12031 0.611176 9.02654 0.837551 9.02654 1.07359V1.94693C7.30004 2.18555 5.71852 3.04176 4.57489 4.357C3.43126 5.67223 2.80302 7.35736 2.80654 9.10026V12.3936C2.72304 13.5117 2.41705 14.602 1.90654 15.6003C1.44712 16.3218 0.893333 16.9788 0.25987 17.5536L0.0332031 17.7536V19.6336H19.8999V17.7536Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.be75e849a227bdb1eac230eafd5fc49b.svg";
export { ForwardRef as ReactComponent };